import { mergeStyleSets } from "@fluentui/merge-styles";
import { useMemo } from "react";
import { flex } from "Utils/Styles";

const classNames = {
  root: `PoweredBy`,
  logo: `PoweredByLogo`
};

export function usePoweredByStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          ...flex,
          alignItems: `flex-end`,
          justifyContent: `center`,
          padding: `5px 24px 5px 0`,
          width: `35%`
        }
      ],
      logo: [
        classNames.logo,
        {
          width: `75px`
        }
      ]
    }),
    []
  );
}
